<template>
  <div class="hora">
    <transition name="fade">
      <div
        class="show container"
        style="font-family: IRANSansX-Regular">
        <div class="row justify-content-md-center row-cols-1 mb-3">
          <div
            class="col-12 col-md-11 col-xl-7 mb-3 chart-form p-2"
            style="
              box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16);
              border: 1px solid rgba(0, 0, 0, 0.175);
              border-radius: 8px;
              background: #fff;
            "
          >
            <ChartFormPrashnaFree
              @appViewUpdateData="updateLoadedData"
            />
          </div>

          <div class="w-100"/>

          <div class="w-100"/>

          <div
            v-if="loadData['user']"
            class="col-12 col-md-11 col-xl-7 mr-auto mx-auto order-2 p-0 p-md-2 mb-3">
            <div
              class="p-3"
              style="
              border-radius: 8px;
              border: 1px solid #ccc;
              box-shadow: rgba(0, 0, 0, 0.16) 0px 2px 2px;
              background-color: #fff;
              direction: rtl;
            "
            >
              <div class="row">
                <div class="col-12 lh-lg">
                  <div
                    class="rounded p-3"
                    style="background-color: #f9f9f9; border: 1px solid rgba(238, 238, 238, 0.5); color: #000 ;font-size: 16px;">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-eye"
                      viewBox="0 0 16 16">
                      <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
                      <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>
                    </svg>
                    شما در حال مشاهده پرشنا به وقت
                    {{ loadData['user']['city'] }}
                    در ساعت
                    <span dir="ltr">
                      {{ `${loadData['user']['hour']}:${loadData['user']['min']}:${loadData['user']['sec']}` }}
                    </span>&nbsp;
                    در تاریخ
                    <span dir="ltr">
                      {{ `${loadData['user']['j_year']}-${loadData['user']['j_month']}-${loadData['user']['j_day']}` }}
                    </span>&nbsp;
                    <span dir="ltr">
                      ({{ `${loadData['user']['year']}-${loadData['user']['month']}-${loadData['user']['day']}` }})
                    </span>&nbsp;
                    هستید.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-11 col-xl-7 mr-auto mx-auto order-2 p-0 p-md-2">
            <PrashnaFreeChartInfo
              v-if="loadData['user']"
              :data="loadData"
            />
          </div>
        </div>

        <div
          class="row justify-content-md-center"
          style="direction: ltr">
          <div
            ref="chart_box"
            class="col-12 col-md-11 col-lg-6 mr-auto mx-auto mb-3 p-0">
            <div
              v-if="loadData['bhava'] && loadData['graha']"
              id="accordionExample3"
              :style="`width: ${main_box_width}px; box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16); border-radius: 7px;`"
              class="accordion mr-auto mx-auto"
            >
              <div class="accordion-item">
                <h2
                  id="headingTwo3"
                  class="accordion-header">
                  <button
                    class="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo3"
                    aria-expanded="false"
                    aria-controls="collapseTwo3"
                  >
                    D1 - Rashi Chart
                  </button>
                </h2>
                <div
                  id="collapseTwo3"
                  class="accordion-collapse show"
                  aria-labelledby="headingTwo3"
                  data-bs-parent="#accordionExample3"
                >
                  <div class="accordion-body p-0">
                    <keep-alive>
                      <Chart
                        v-if="loadData['bhava'] && loadData['graha']"
                        :varga_number="'D1'"
                        :varga_name="'Rasi'"
                        :bhavas="loadData['bhava']"
                        :grahas="loadData['graha']"
                        :show_degree="true"
                        :is_main_chart="true"
                        :box_width="main_box_width - 5"
                        :bg_color="loadData['bg_chart']"
                        class="mr-auto mx-auto"
                      />
                    </keep-alive>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="loadData['user']"
            class="col-12 col-md-11 col-lg-6 mr-auto mx-auto mb-3 p-0"
          >
            <div
              v-if="loadData['bhava'] && loadData['graha']"
              id="accordionExample4"
              :style="`width: ${box_width}px; box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16); border-radius: 7px;`"
              class="accordion mr-auto mx-auto"
            >
              <div class="accordion-item">
                <h2
                  id="headingTwo4"
                  class="accordion-header">
                  <button
                    class="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo4"
                    aria-expanded="false"
                    aria-controls="collapseTwo4"
                    v-text="chart2Text"
                  />
                </h2>
                <div
                  id="collapseTwo4"
                  class="accordion-collapse show"
                  aria-labelledby="headingTwo4"
                  data-bs-parent="#accordionExample4"
                >
                  <div class="accordion-body p-0">
                    <keep-alive>
                      <Chart
                        v-if="loadData['varga']"
                        :varga_number="this.chart2Varga"
                        :varga_name="'Navamsa'"
                        :bhavas="loadData['varga']['D9']['bhava']"
                        :grahas="loadData['varga']['D9']['graha']"
                        :show_degree="false"
                        :is_main_chart="false"
                        :box_width="box_width - 5"
                        :bg_color="loadData['bg_chart']"
                        class="mr-auto mx-auto"
                      />
                    </keep-alive>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="loadData['user']"
          class="row justify-content-md-center"
          style="direction: ltr"
        >
          <div class="col-12 col-md-11 col-lg-6 mr-auto mx-auto mb-3 p-0">
            <div
              id="accordionPanelsStayOpenPlanetryPlanetry"
              :style="`width: ${main_box_width}px`"
              class="accordion mr-auto mx-auto"
              style="box-shadow: rgba(0, 0, 0, 0.16) 0px 2px 2px; border-radius: 8px"
            >
              <div class="accordion-item">
                <h2
                  id="panelsStayOpenPlanetry-headingOne"
                  class="accordion-header">
                  <button
                    class="accordion-button accordion-custom-butt on"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpenPlanetry-collapseOne"
                    aria-expanded="true"
                    aria-controls="panelsStayOpenPlanetry-collapseOne"
                  >
                    جدول سیاره‌ای
                  </button>
                </h2>
                <div
                  id="panelsStayOpenPlanetry-collapseOne"
                  class="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpenPlanetry-headingOne"
                >
                  <div
                    class="accordion-body p-1"
                    style="background-color: #f9f9f9; overflow-y: scroll"
                  >
                    <PlanetryTableFree
                      :show_nakshatra="true"
                      :grahas="loadData['graha']"
                      :lagna="loadData['lagna']"
                      :box_width="main_box_width"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Chart from '../components/Chart.vue'
import ChartListPro from '../components/ChartListPro.vue'
import ChartNoteListPro from '../components/ChartNoteListPro.vue'
import PrashnaFreeChartInfo from '../components/PrashnaFreeChartInfo.vue'
import ShareLinkFree from '../components/ShareLinkFree.vue'
import ChartFormPrashnaFree from '../components/ChartFormPrashnaFree.vue'
import PlanetryTableFree from '../components/PlanetryTableFree.vue'
import DashaTable from '../components/DashaTable.vue'
import HelperLib from '../components/helper'
import HoraLogo from '../components/HoraLogo.vue'
import NoteListPro from '../components/NoteListPro.vue'
import DatePicker from '../components/DatePicker.vue'
import TimePicker from '../components/TimePicker.vue'
import TransitForm from '../components/TransitForm.vue'
import ApiService from '../service/api'

export default {
  name: 'FreePrashnaView',
  components: {
    Chart,
    ChartListPro,
    PrashnaFreeChartInfo,
    ChartFormPrashnaFree,
    PlanetryTableFree,
    DashaTable,
    HelperLib,
    HoraLogo,
    ShareLinkFree,
    DatePicker,
    TimePicker,
    TransitForm,
    // ChartNotesPro,
    NoteListPro,
    ChartNoteListPro,
    ApiService
  },
  data () {
    return {
      chart2Varga: 'D9',
      chart3Varga: 'D30',
      chart2Text: 'D9 - Navamsa Chart',
      chart3Text: 'D30 - Trimshamsha',
      link_clicked: false,
      loadData: [],
      box_width: null,
      main_box_width: null,
      pages: {
        is_calculate: true,
        is_charts: false,
        is_notes: false
      }
    }
  },
  watch: {
    loadData: function (data) {
      this.loadData = data
    }
  },
  mounted: function () {
    this.adjustBoxesWidth()
  },
  methods: {
    adjustBoxesWidth () {
      if (screen.width > 960) {
        // DESKTOP
        this.box_width = (this.$refs.chart_box.clientWidth * 92) / 100
        this.main_box_width = (this.$refs.chart_box.clientWidth * 97) / 100
      } else {
        this.box_width = (this.$refs.chart_box.clientWidth * 100) / 100
        this.main_box_width = this.box_width
      }
    },

    isMobile () {
      return HelperLib.isMobile()
    },
    showMobileViewChartHeader (width) {
      return `
      font-size: 12px; 
      border-radius: 8px; 
      width: ${width}px;  
      line-height: 10px; 
      color: #000;`
    },
    formatLocation (user) {
      let lonDir = user['longitude'] < 0 ? 'W' : 'E'
      let latDir = user['latitude'] < 0 ? 'S' : 'N'
      let out =
        user['latitude_dms']['deg'] +
        ' ' +
        latDir +
        ' ' +
        user['latitude_dms']['min'] +
        ' - '
      out +=
        user['longitude_dms']['deg'] + ' ' + lonDir + ' ' + user['longitude_dms']['min']
      return out
    },
    formatLagnaText (rashi) {
      return HelperLib.rashiToPersianText(rashi)
    },
    getSignLink (data) {
      var lagna = HelperLib.rashiToPersianText(data['lagna']['Lg']['rashi'])
      return `${lagna[1]}`
    },
    updateLoadedData (data) {
      this.loadData = data
    }
  }
}
</script>

<style scoped>
.custom-accordion-header {
  background-color: #f2f2f2;
  color: #333;
  border: 1px solid #ccc;
}

.custom-accordion-header:hover {
  background-color: #e6e6e6;
}

.custom-accordion-header.active {
  background-color: #ddd;
}
.accordion-button-custom:not(.collapsed) {
  color: #000000;
  font-weight: bold;
  background-color: #fff;
  box-shadow: inset 0 -1px 0 rgb(0 0 0 / 13%);
}

* {
  padding: 0px;
  margin: 0px;
}
.now-analysis {
  direction: rtl;
  text-align: right;
  background-color: rgba(255, 253, 231, 0.5);
  border-radius: 0.25rem;
  font-size: 16px;
  color: black;
  border: 1px solid rgb(242, 242, 242);
}
.loading {
  left: 0px;
  top: 0px;
  right: 0px;
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: rgba(255, 255, 255, 0.8);
}
</style>
<!-- <style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style> -->
